import { useMemo, useCallback } from "react";
import { analytics } from "@lib/trackers/analytics";
import { useCurrentUser } from "@hooks/use-current-user";
import { userState } from "@utils/constants/user";

export function useProductsViewedEvent() {
  const user = useCurrentUser();

  const userGroup = useMemo(() => {
    if (!user) return null;
    if (user.c1_dedicated) return "c1";
    if (user.user_group.includes("trying")) return "trying";

    return "confirmed";
  }, [user]);

  return useCallback(
    (source, hubOrListingPageSlug, productsUids, filters = {}, abTest = {}) => {
      if (!user || user.state !== userState.subscriber) return;

      analytics.track("products_list_view", {
        source: source,
        hub_or_listing_page_slug: hubOrListingPageSlug,
        product_uids: productsUids,
        filters: filters,
        user_group: userGroup,
        origin: "next_js",
        ab_test: abTest,
      });
    },
    [user, userGroup],
  );
}
